import React from 'react';
import { motion } from 'framer-motion';
import { CONTACTS } from '../constants/info'; // Importar informações de contacto
import '../assets/css/Contacts.css';

// --- Framer Motion Variants ---

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15, // Intervalo entre os elementos
    },
  },
}

const itemVariants = {
  hidden: { y: 30, opacity: 0, scale: 0.95 },
  visible: { y: 0, opacity: 1, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

// --- Contacts Component ---

const Contacts = () => {
  return (
    <motion.section
      className="contacts-page-container"
      id="contatos"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      variants={containerVariants}
    >
      <motion.h1 className="main-title" variants={itemVariants}>Fale Connosco</motion.h1>

      <div className="contacts-content-layout">
        <motion.div
          className="contacts-info-column"
          variants={itemVariants}
        >
          <ul className="contact-info-list">
            {/* */}
            <li>
              <i className="bi bi-person-fill contact-icon"></i> {CONTACTS.secretary.join(', ')}
            </li>
            <li>
              <i className="bi bi-whatsapp contact-icon"></i>
              <a href={`https://wa.me/${CONTACTS.phone.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer">{CONTACTS.phone}</a>
            </li>
            <li>
              <i className="bi bi-facebook contact-icon"></i>
              <a href={CONTACTS.facebook} target="_blank" rel="noopener noreferrer">@talatonakids</a>
            </li>
            <li>
              <i className="bi bi-instagram contact-icon"></i>
              <a href={CONTACTS.instagram} target="_blank" rel="noopener noreferrer">@talatona_kids</a>
            </li>
            <li>
              <i className="bi bi-envelope-fill contact-icon"></i>
              <a href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</a>
            </li>
            <li>
              <i className="bi bi-geo-alt-fill contact-icon"></i>
              <a href={CONTACTS.maps} target="_blank" rel="noopener noreferrer">{CONTACTS.address}</a>
            </li>
          </ul>
        </motion.div>

        <motion.div
          className="contacts-map-column"
          variants={itemVariants}
        >
          <iframe
            title="Talatona Kids Location"
            src={CONTACTS.maps}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="map-iframe"
          ></iframe>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Contacts;